<template>
  <section class="ProgramDescription">
    <BaseInvisible tag="h3">Program Description</BaseInvisible>
    <div v-html="splitDescription[0]"/>
    <DisclosureContainer
      v-if="splitDescription[1]"
      :id="containerId"
      transition="TransitionSlide"
      class="ProgramDescription__copy-rest"
      @toggle="expanded = !expanded"
      v-html="splitDescription[1]"
    />
    <DisclosureButton
      v-if="splitDescription[1]"
      :controls="containerId"
      class="ProgramDescription__button"
    >
      <TextEpsilon
        class="ProgramDescription__button-text"
        v-text="!expanded ? 'Read More' : 'Close'"
      />
      <DisclosureIndicator
        :expanded="expanded"
        class="ProgramDescription__button-indicator"
      />
    </DisclosureButton>
    <LinkCta
      v-if="mailto"
      :href="mailto"
      class="ProgramDescription__link"
    />
  </section>
</template>

<script>
  import LinkCta from './LinkCta';
  import TextEpsilon from './TextEpsilon';
  import DisclosureButton from './DisclosureButton';
  import DisclosureContainer from './DisclosureContainer';
  import DisclosureIndicator from './DisclosureIndicator';

  export default {
    components: {
      LinkCta,
      TextEpsilon,
      DisclosureButton,
      DisclosureContainer,
      DisclosureIndicator,
    },
    props: {
      description: {
        type: String,
        required: true,
      },
      mailto: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      containerId() {
        return `container-${this._uid}`;
      },
      splitDescription() {
        const match = this.description.match(/<p>.*?<\/p>/g);

        if (!match) {
          return [];
        }

        const [first, ...rest] = match;

        return [
          first,
          rest.join(''),
        ];
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .ProgramDescription {
    line-height: 1.5;
  }

  .ProgramDescription__button {
    margin-top: spacing(base-beta);
    display: flex;
    padding: spacing(base-alpha);
    align-items: center;

    @include breakpoint(phablet) {
      display: none;
    }
  }

  .ProgramDescription__button-indicator {
    margin-left: spacing(base-alpha);
  }

  .ProgramDescription__button-text {
    color: color(bronze);
  }

  .ProgramDescription__copy-rest {
    padding-top: spacing(base-beta);

    @include breakpoint(phablet) {
      display: block !important;
    }
  }

  .ProgramDescription__link {
    display: inline-block;
    margin-top: spacing(base-gamma);
  }
</style>
